import { ResourceGroupService } from '../../../services/resource-group'
import { ResourceGroup } from '@mprep/shared/data/models'
import { IDataServiceConfig } from '@mprep/shared/lib/model-repository'
import { ModelRepository } from '@mprep/shared'

export const ResourceGroupConfig: IDataServiceConfig<ResourceGroup> = {
  service: ResourceGroupService,
  deps: [ModelRepository],
  endpoint: 'resources/resource_groups?filter[user-id]=:user_id',
  model: ResourceGroup,
  presenter: null,
  backend: 'cached',
  mappings: [
    {
      jsonType: 'resource-groups',
      classType: 'ResourceGroup',
      propertyMapping: {
        menuItems: {
          type: 'ResourceGroup',
          isCollection: true
        }
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/app/shared/services/model-repository/mappings/resource-group.config.ts